
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component
export default class PotentialTrade extends Vue {}
